"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mazzin": {
    "4af67ddf": [{
      "hkey": "d3522d81",
      "slug": "fontanazzo",
      "name": "Fontanazzo",
      "primary": true,
      "skipSearch": false
    }],
    "fontanazzo-di-sopra": [{
      "hkey": "d3522d81",
      "slug": "fontanazzo",
      "name": "Fontanazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mazzin"
    }],
    "2300abae": [{
      "hkey": "d3522d81",
      "slug": "fontanazzo",
      "name": "Fontanazzo",
      "primary": true,
      "skipSearch": false
    }],
    "fontanazzo-di-sotto": [{
      "hkey": "d3522d81",
      "slug": "fontanazzo",
      "name": "Fontanazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mazzin"
    }]
  }
};
exports["default"] = _default;